import { VillageUIThemeProvider } from '@village/ui';
import { cityMdTheme } from 'citymd/theme';
import { FC, PropsWithChildren } from 'react';

import { CustomGlobalStyles } from './custom-global-styles';

const ThemeProvider: FC<PropsWithChildren> = ({ children }) => {
    return (
        <VillageUIThemeProvider theme={cityMdTheme}>
            <CustomGlobalStyles />
            {children}
        </VillageUIThemeProvider>
    );
};

export { ThemeProvider };
